import { Injectable } from '@angular/core';

import { LogoutResponse } from '@reach/interfaces/auth/auth.responses';
import { Language } from '@reach/interfaces/user/language.enum';
import { UserWithoutSensitive } from '@reach/interfaces/user/user.interface';
import { UserInPing } from '@reach/interfaces/user/user-in-ping';

import { BaseApiService } from '~/core/services/api/base.api.service';

@Injectable({ providedIn: 'root' })
export class AuthApiService extends BaseApiService {
	protected readonly commonPath = ['auth'];

	public async ping(): Promise<UserInPing> {
		const params = { t: this.paramTime };

		const res = await this.http.get<UserInPing>(this.url('ping'), params);
		return res;
	}

	public async login(username: string, password: string): Promise<UserInPing> {
		const body = {
			username,
			password,
		};

		const res = await this.http.post<UserInPing>(this.url('login'), body);
		return res;
	}

	public async logout(): Promise<LogoutResponse> {
		await this.http.post<LogoutResponse>(this.url('logout'), {});
	}

	public async signInWithMicrosoft(accessToken: string, language: Language): Promise<UserInPing> {
		const body = {
			accessToken,
			language,
		};
		return await this.http.post<UserWithoutSensitive>(this.url('social', 'azure'), body);
	}
}
